import { Injectable } from '@angular/core';
import { DataModel, PrimaryKeyValueModel } from '@shared';
import { WorkspaceDatabaseProvider } from '../workspace-database.provider';
import { WorkspaceDatabaseKeys } from '../schemas';
import { Observable } from 'rxjs';
import { RxDocument } from 'rxdb';
import { map } from 'rxjs/operators';
import { QueryBuilder } from './builders/query.builder';
import { QueryOperatorsEnum } from '../models/query-operators.enum';
import { addRxPlugin } from 'rxdb';
import { RxDBQueryBuilderPlugin } from 'rxdb/plugins/query-builder';
addRxPlugin(RxDBQueryBuilderPlugin);

@Injectable()
export class SamplesRepository {
	public constructor(private dbProvider: WorkspaceDatabaseProvider) {}

	public getDuplicateSampleByParentNumber$(
		tableName: string,
		projectNumber: string,
		parentSampleNumber: string,
		excludedIds: number[],
		primaryKeyValue?: PrimaryKeyValueModel[]
	): Observable<DataModel[]> {
		if (!primaryKeyValue) {
			const dbQuery = new QueryBuilder();
			excludedIds.forEach((x) => {
				dbQuery.addCondition(WorkspaceDatabaseKeys.internalColumns.rxdbid, QueryOperatorsEnum.notEqual, x);
			});

			dbQuery.addCondition(WorkspaceDatabaseKeys.columns.projectNumber, QueryOperatorsEnum.equal, projectNumber);
			dbQuery.addCondition(WorkspaceDatabaseKeys.internalColumns.isDeleted, QueryOperatorsEnum.equal, false);
			dbQuery.addCondition(
				WorkspaceDatabaseKeys.columns.parentSampleNumber,
				QueryOperatorsEnum.equal,
				parentSampleNumber
			);

			return this.dbProvider
				.getDatabaseCollection(tableName.toLowerCase())
				.find(dbQuery.build())
				.$.pipe(
					map((items: RxDocument<DataModel>[]) => items.map((item: RxDocument<DataModel>) => item.toJSON()))
				);
		}

		return this.getDuplicateSampleByParentNumberAndPk$(
			tableName,
			projectNumber,
			parentSampleNumber,
			excludedIds,
			primaryKeyValue
		);
	}

	public getDuplicateSampleByParentNumberAndPk$(
		tableName: string,
		projectNumber: string,
		parentSampleNumber: string,
		excludedIds: number[],
		primaryKeyValue: PrimaryKeyValueModel[]
	): Observable<DataModel[]> {
		const dbQuery = new QueryBuilder();
		dbQuery.addPrimaryKeys(primaryKeyValue);
		// dbQuery.addCondition(WorkspaceDatabaseKeys.internalColumns.rxdbid, QueryOperatorsEnum.notIn, excludedIds);
		excludedIds.forEach((x) => {
			dbQuery.addCondition(WorkspaceDatabaseKeys.internalColumns.rxdbid, QueryOperatorsEnum.notEqual, x);
		});

		dbQuery.addCondition(WorkspaceDatabaseKeys.columns.projectNumber, QueryOperatorsEnum.equal, projectNumber);
		dbQuery.addCondition(WorkspaceDatabaseKeys.internalColumns.isDeleted, QueryOperatorsEnum.equal, false);
		dbQuery.addCondition(
			WorkspaceDatabaseKeys.columns.parentSampleNumber,
			QueryOperatorsEnum.equal,
			parentSampleNumber
		);

		return this.dbProvider
			.getDatabaseCollection(tableName.toLowerCase())
			.find(dbQuery.build())
			.$.pipe(map((items: RxDocument<DataModel>[]) => items.map((item: RxDocument<DataModel>) => item.toJSON())));
	}
}
